interface Props {
  onCta: () => void;
}

export function CTASection({ onCta }: Props): JSX.Element {
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-6">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-lime-500/20 via-ink-800 to-ink-900 border border-lime-500/30 p-10 md:p-16 text-center">
          <div className="absolute inset-0 -z-10">
            <div className="absolute top-0 left-1/4 w-96 h-96 bg-lime-500/20 blur-3xl rounded-full" />
            <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-lime-500/10 blur-3xl rounded-full" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight max-w-2xl mx-auto leading-tight">
            Gotowy na <span className="text-lime-500">pierwsze zdanie</span> po angielsku?
          </h2>
          <p className="mt-5 text-ink-300 text-lg max-w-xl mx-auto">
            Pierwsza lekcja za 0 zł. Bez karty kredytowej. 5 minut konfiguracji.
          </p>
          <button
            onClick={onCta}
            className="mt-8 inline-flex items-center gap-2 bg-lime-500 hover:bg-lime-400 text-ink-900 font-semibold rounded-xl px-8 py-4 text-lg shadow-glow-lime transition"
          >
            Zacznij za darmo →
          </button>
          <div className="mt-6 text-xs text-ink-400 uppercase tracking-widest">
            Dołącz do tysięcy uczących się w Tutor
          </div>
        </div>
      </div>
    </section>
  );
}
